import { FormLabelAlign } from 'antd/es/form/interface'
import { ColProps } from 'antd'

import {
  EGameType,
  ELanguage,
  EPostFormat,
  EStatusDeal,
  EStatusDelete,
  EStatusDoc,
  ETargetNotification,
  EStatusReward,
  TStatusDoc,
  TStatusDocDeal,
  TStatusDocNoti,
  EGameWheelType,
} from './interface.config'

export const ROLE_INIT = ['ADMINISTRATOR', 'EDITOR', 'GUEST']

export const FORMAT_TIME_DEFAULT = 'YYYY-MM-DD HH:mm:ss'

export const FORMAT_TIME_DEFAULT_EXPORT_NAME = 'YYYYMMDD-HHmmss'

export const FOLDER_ROOT_ID = '637538b18bb90293ce4a39dd'
export const TAXONOMY_ROOT_ID = '60ab1c94c974f54870e9e64c'
export const NSuccess = 'Notification Success'
export const NError = 'Notification Error'
export const NWarning = 'Notification Warning'

export const LANGUAGE_DEFAULT = ELanguage.VI

export const LANGUAGE_CODE = [ELanguage.VI, ELanguage.EN, ELanguage.JA]

export const FORMAT_POST = [
  EPostFormat.GALLERY,
  EPostFormat.HTML,
  EPostFormat.PDF,
  EPostFormat.VIDEO,
  EPostFormat.WEBVIEW,
]

export const labelStyle: { labelAlign: FormLabelAlign; labelCol: ColProps } = {
  labelCol: { span: 5 },
  labelAlign: 'left',
}
export const labelStyleSpan20 = {
  ...labelStyle,
  labelCol: { span: 20 },
}

export const labelChildren: { labelAlign: FormLabelAlign; labelCol: ColProps } = {
  ...labelStyle,
  labelAlign: 'right',
}

export const STATUS_DOCUMENT_SELECT: TStatusDoc[] = [
  { key: 1, value: EStatusDoc.ACTIVE, status: 'success' },
  { key: 2, value: EStatusDoc.INACTIVE, status: 'error' },
  { key: 3, value: EStatusDoc.DRAFT, status: 'default' },
]

export const STATUS_NOTIFICATION_SELECT: TStatusDocNoti[] = [
  { key: 1, value: ETargetNotification.ALL, status: 'success' },
  { key: 2, value: ETargetNotification.OPTION, status: 'error' },
]

export const STATUS_DEAL_SELECT: TStatusDocDeal[] = [
  { key: 1, value: EStatusDeal.NEW, status: 'success' },
  { key: 2, value: EStatusDeal.OLD, status: 'error' },
]
export const STATUS_PRODUCT_SELECT: TStatusDoc[] = [
  ...STATUS_DOCUMENT_SELECT,
  { key: 4, value: EStatusDoc.PENDING, status: 'processing' },
]

export const STATUS_REWARD_USER_SELECT: {
  text: string
  value: EStatusReward
}[] = [
  { text: EStatusReward.COMPLETE.toLocaleUpperCase(), value: EStatusReward.COMPLETE },
  { text: EStatusReward.CANCEL.toLocaleUpperCase(), value: EStatusReward.CANCEL },
  { text: EStatusReward.PENDING.toLocaleUpperCase(), value: EStatusReward.PENDING },
]

export const STATUS_DELETE_SELECT: {
  text: string
  value: EStatusDelete
}[] = [
  { text: EStatusDelete.COMPLETE.toLocaleUpperCase(), value: EStatusDelete.COMPLETE },
  { text: EStatusDelete.CANCEL.toLocaleUpperCase(), value: EStatusDelete.CANCEL },
  { text: EStatusDelete.PENDING.toLocaleUpperCase(), value: EStatusDelete.PENDING },
  { text: EStatusDelete.DELETE.toLocaleUpperCase(), value: EStatusDelete.DELETE },
]

export const STATUS_SPECIAL_USER_SELECT: {
  text: string
  value: EStatusReward
}[] = [
  { text: EStatusReward.COMPLETE.toLocaleUpperCase(), value: EStatusReward.COMPLETE },
  { text: EStatusReward.CANCEL.toLocaleUpperCase(), value: EStatusReward.CANCEL },
  { text: EStatusReward.PENDING.toLocaleUpperCase(), value: EStatusReward.PENDING },
]
export const STATUS_DOCUMENT_FILTER: {
  text: string
  value: EStatusDoc
}[] = [
  { text: EStatusDoc.ACTIVE.toLocaleUpperCase(), value: EStatusDoc.ACTIVE },
  { text: EStatusDoc.INACTIVE.toLocaleUpperCase(), value: EStatusDoc.INACTIVE },
  { text: EStatusDoc.PENDING.toLocaleUpperCase(), value: EStatusDoc.PENDING },
  { text: EStatusDoc.DRAFT.toLocaleUpperCase(), value: EStatusDoc.DRAFT },
]

export const FORMAT_POST_FILTER: {
  text: string
  value: EPostFormat
}[] = [
  { text: EPostFormat.HTML, value: EPostFormat.HTML },
  { text: EPostFormat.PDF, value: EPostFormat.PDF },
  { text: EPostFormat.GALLERY, value: EPostFormat.GALLERY },
  { text: EPostFormat.VIDEO, value: EPostFormat.VIDEO },
  { text: EPostFormat.WEBVIEW, value: EPostFormat.WEBVIEW },
]

export const TYPE_GAME_FILTER: {
  text: string
  value: EGameType
}[] = [
  { text: EGameType.QUIZ, value: EGameType.QUIZ },
  { text: EGameType.SINGLE, value: EGameType.SINGLE },
  { text: EGameType.WHEEL, value: EGameType.WHEEL },
]

export const TYPE_WHEEL_GAME_FILTER: {
  text: string
  value: EGameWheelType
}[] = [
  { text: EGameWheelType.GIFT, value: EGameWheelType.GIFT },
  { text: EGameWheelType.POINT, value: EGameWheelType.POINT },
]

export const FIELDS_USER_EXPORT_DEFAULT = [
  {
    header: 'Username',
    key: 'username',
    width: 30,
  },
  {
    header: 'Full name',
    key: 'fullName',
    width: 40,
  },
  {
    header: 'Phone',
    key: 'phone',
    width: 20,
  },
  {
    header: 'Org name',
    key: 'orgName',
    width: 40,
  },
  {
    header: 'Branch Name',
    key: 'branchName',
    width: 40,
  },
]
